<template>
    <el-dialog
        class="w-el-dialog"
        :visible.sync="visible"
        width="520px"
        append-to-body
        title="生成周报"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="Close">
        <el-alert
            type="info"
            :closable="false"
            show-icon
            title="按所选成员本周工单调用 AI 生成周报，加入队列后稍后可在列表中查看。"
            style="margin-bottom: 16px;">
        </el-alert>
        <el-form :model="form" label-position="top" v-loading="loading">
            <el-form-item label="成员" required>
                <users-select v-model="form.users_id" multiple placeholder="请选择成员" />
            </el-form-item>
            <el-form-item label="汇报周期" required>
                <el-date-picker
                    v-model="form.week"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择该周任意一天"
                    :style="{ width: '100%' }">
                </el-date-picker>
                <div class="week-hint" v-if="WeekRange">将生成：{{ WeekRange }}</div>
            </el-form-item>
            <el-form-item label="强制重新生成">
                <el-switch v-model="form.force"></el-switch>
                <div class="week-hint">开启后覆盖该周已有周报（含已确认），并清空确认状态。</div>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button @click="Close()">取 消</el-button>
            <el-button type="primary" @click="Submit()" :loading="loading">加入生成队列</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    data () {
        return {
            visible: false,
            form: this.EmptyForm()
        }
    },
    computed: {
        loading () {
            return !!this.$store.state.httpRequestCount
        },
        WeekRange () {
            return this.FormatWeekRange(this.form.week)
        }
    },
    methods: {
        EmptyForm () {
            return {
                users_id: null,
                week: this.Today(),
                force: false
            }
        },
        NormalizeIds (usersId) {
            if (usersId == null || usersId === '') return []
            const list = Array.isArray(usersId) ? usersId : [usersId]
            return list.filter(id => id !== null && id !== undefined && id !== '' && !Array.isArray(id))
        },
        Today () {
            const now = new Date()
            return this.PadDate(now)
        },
        PadDate (date) {
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return y + '-' + m + '-' + d
        },
        FormatWeekRange (dateStr) {
            if (!dateStr) return ''
            const parts = String(dateStr).substring(0, 10).split('-').map(Number)
            if (parts.length !== 3 || parts.some(n => !n && n !== 0)) return ''
            const date = new Date(parts[0], parts[1] - 1, parts[2])
            if (Number.isNaN(date.getTime())) return ''
            const day = date.getDay()
            const offset = day === 0 ? -6 : 1 - day
            const monday = new Date(date)
            monday.setDate(date.getDate() + offset)
            const sunday = new Date(monday)
            sunday.setDate(monday.getDate() + 6)
            return this.PadDate(monday) + ' 至 ' + this.PadDate(sunday)
        },
        Open () {
            this.form = this.EmptyForm()
            this.visible = true
        },
        Close () {
            this.visible = false
            this.form = this.EmptyForm()
        },
        Submit () {
            const usersId = this.NormalizeIds(this.form.users_id)
            if (!usersId.length) {
                this.$message.warning('请选择成员')
                return
            }
            if (!this.form.week) {
                this.$message.warning('请选择汇报周期')
                return
            }

            const post = () => {
                return this.$http.post('/9api/pm/weekly-report/generate', {
                    users_id: usersId,
                    week: this.form.week,
                    force: this.form.force
                }).then(res => {
                    if (!res) return
                    this.$message.success(res.data.message || '已加入生成队列')
                    this.$emit('onChange')
                    this.Close()
                })
            }

            if (this.form.force) {
                this.$confirm('强制重新生成会覆盖该周已有周报（含已确认），并清空确认状态。是否继续？', '强制重新生成', {
                    confirmButtonText: '继续生成',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(post).catch(() => {})
                return
            }
            post()
        }
    }
}
</script>

<style lang="less" scoped>
.week-hint {
    margin-top: 6px;
    color: #909399;
    font-size: 12px;
    line-height: 1.5;
}
</style>
